export default __webpack_public_path__ + "f20ee7394c4af8e6b71f7206ecd8f8a3.png";